export default "__VITE_ASSET__3eqIdKwd__"